import brandImg from '@/assets/imgs/brand/logo.png';
import { dedicatedWalletConnector } from '@magiclabs/wagmi-connector';
import {
  bitcoinChain,
  CUSTOM_RPC_BY_CHAIN,
  SUPPORTED_CHAINS,
} from '@package/smart-wallet/constants';
import { useChainStore } from '@package/smart-wallet/store';
import { http } from 'viem';
import { createConfig, createConnector } from 'wagmi';
import { arbitrum, base, bsc, mainnet, polygon } from 'wagmi/chains';

export const getMagicConnectorFn = (
  id: string,
  name: string = 'Magic',
  chainId: number = bsc.id,
) => {
  const walletDetails = {
    id,
    name,
    rdns: 'Magic',
    iconBackground: '#fff',
    installed: true,
    iconAccent: '#b4acfc',
    downloadUrls: {},
    type: id,
  };

  const magicConnector = dedicatedWalletConnector({
    chains: Object.values(SUPPORTED_CHAINS)
      .map((config) => config.chain)
      .filter((chain) => chain.id !== 0),
    options: {
      isDarkMode: true,
      apiKey: import.meta.env.VITE_MAGIC_API_KEY,
      customLogo: brandImg,
      accentColor: '#141414',
      customHeaderText: 'Manum App',
      oauthOptions:
        import.meta.env.VITE_ENABLE_MAGIC_SOCIAL_LOGIN === 'true'
          ? {
              providers: ['google'],
            }
          : undefined,
      magicSdkConfiguration: {
        network: {
          rpcUrl: CUSTOM_RPC_BY_CHAIN[chainId],
          chainId,
        },
      },
    },
  });

  return createConnector(
    (config) =>
      ({
        ...magicConnector(config),
        ...walletDetails,
        type: id,
        id,
      }) as any,
  );
};

// Get initial chain from localStorage or default to BSC
const getInitialChainId = (): number => {
  if (typeof window !== 'undefined') {
    const stored = useChainStore.getState().chainId;
    console.log('Stored chainId in localStorage:', stored);
    if (!!stored && stored !== bitcoinChain.id) {
      const chainId = Number(stored);
      // Validate that it's a supported chain
      if (SUPPORTED_CHAINS[chainId]) {
        return chainId;
      }
    }
  }
  return bsc.id; // Default to BSC
};

const initialChainId = getInitialChainId();
const initialChain = SUPPORTED_CHAINS[initialChainId]?.chain || bsc;

export const config = createConfig({
  autoConnect: false,
  // @ts-expect-error Wagmi wait for constant type
  chains: Object.values(SUPPORTED_CHAINS)
    .map((config) => config.chain)
    .filter((chain) => chain.id !== 0),
  transports: {
    [mainnet.id]: http(CUSTOM_RPC_BY_CHAIN[mainnet.id]),
    [polygon.id]: http(CUSTOM_RPC_BY_CHAIN[polygon.id]),
    [bsc.id]: http(CUSTOM_RPC_BY_CHAIN[bsc.id]),
    [arbitrum.id]: http(CUSTOM_RPC_BY_CHAIN[arbitrum.id]),
    [base.id]: http(CUSTOM_RPC_BY_CHAIN[base.id]),
  },
  connectors: [
    getMagicConnectorFn(
      `magic-${initialChainId}`,
      `Magic ${initialChain.name}`,
      initialChainId,
    ),
  ],
});
